import { requestWithMethod } from "../helpers/request";

export function fetchRealEstateGroupMetrics(params = {}) {
  const body = {};

  if (params.start_date) {
    body.start_date = params.start_date;
  }
  if (params.end_date) {
    body.end_date = params.end_date;
  }
  if (params.broker_ids) {
    body.broker_ids = Array.isArray(params.broker_ids)
      ? params.broker_ids
      : params.broker_ids.split(",");
  }
  if (params.traffic_source_ids) {
    body.traffic_source_ids = Array.isArray(params.traffic_source_ids)
      ? params.traffic_source_ids
      : params.traffic_source_ids.split(",");
  }
  if (params.conversion_mode) {
    body.conversion_mode = params.conversion_mode;
  }
  if (params.funnel_stages && params.funnel_stages.length > 0) {
    body.funnel_stages = Array.isArray(params.funnel_stages)
      ? params.funnel_stages
      : params.funnel_stages.split(",");
  }
  if (params.time_metrics) {
    body.time_metrics = params.time_metrics;
  }

  return requestWithMethod("/RealEstateGroup/metrics", {
    method: "POST",
    body: JSON.stringify(body)
  });
}
